// src/checkout/legacyForm/zustand/runtimeConfigStore.ts
import { create } from "zustand";
var defaultRuntimeConfig = {
  form: {
    checkout_v4_formLabels: {},
    checkout_v4_formHeadings: {},
    checkout_v4_errors: {},
    checkout_v4_payment_method_position: "top",
    hide_paypal_express_button_block: false,
    tr_checkout_v4_disclaimer_text: "",
    tr_checkout_v4_formEncrypted: "",
    tr_checkout_v4_formEncrypted_top: "",
    tr_checkout_v4_form_cta: "",
    tr_checkout_v4_form_processing: "",
    tr_checkout_v4_form_paypalText: "",
    tr_checkout_v4_paypal_upper: "",
    tr_checkout_v4_paypal_bottom: ""
  },
  summary: {},
  products: {},
  globalComponents: {},
  checkboxText: "",
  affiliate: "",
  postId: "",
  cleanDesktop: false,
  cleanMobile: false,
  complianceDesktop: false,
  complianceMobile: false,
  directCheck: false,
  enhancedContrast: false,
  isAdyenEnabled: false,
  isPreview: false
};
var useLegacyRuntimeConfigStore = create((set) => ({
  ...defaultRuntimeConfig,
  setRuntimeConfig: (config) => set(config)
}));
var setLegacyRuntimeConfig = (config) => {
  useLegacyRuntimeConfigStore.getState().setRuntimeConfig(config);
};
var getLegacyRuntimeConfig = () => useLegacyRuntimeConfigStore.getState();

export {
  useLegacyRuntimeConfigStore,
  setLegacyRuntimeConfig,
  getLegacyRuntimeConfig
};
//# sourceMappingURL=chunk-RR2AD6GR.mjs.map